export default function Header() {
  return (
    <div className="text-left mb-5">
      <h1>Aluc4rd.Vette</h1>
      <p><strong><em>Son of Dracula + C4 Corvette</em></strong></p>
      <p>Dallas based Photographer + Car Enthusiast</p>
      <p>📸 Nikon Z6</p>
    </div>
  )
}